<div class="d-flex flex-row">
  <div>
    <app-dashboard-side-menu></app-dashboard-side-menu>
  </div>
  <div class="p-content d-flex flex-column">
    <app-dashboard-top-menu></app-dashboard-top-menu>
    <!--!Necessario estar aqui para não desaparecer quando faz o loading-->
    <a #downloadLink style="display: none;"></a>
    <!-- !!Content to be displayed when loading is complete -->
    @if (loading) {
      <div class="loading-animation">
        <app-loading></app-loading>
      </div>
    } @else {
      <div class="template-content">
        <div class="w-100 d-flex flex-column justify-content-start">
          <div class="d-flex">
            <h2>Importação de produtos</h2>
          </div>
          <div class="d-flex flex-column justify-content-between">
            <form>
              <div class="row">
                <div class="col-md-6 col-xs-12" style="max-width: 440px;">
                  <p>Referência <span>*</span>
                  @if (mandatory) {
                    <span> Obrigatório.</span>
                  }
                  @if (!valid && !mandatory) {
                    <span> Só pode conter números separados por vírgula, sem espaços. Ex.: 0001,0002</span>
                  }
                </p>
                <mat-form-field class="w-100">
                  <input #referenciaCtrl="ngModel" matInput name="referencia" [(ngModel)]="referencia" placeholder="Ex. 0001,0002,0004" pattern="^[0-9,]*$" required>
                  @if (referenciaCtrl.errors?.['pattern']) {
                    <mat-error>
                      Somente números separados por vírgula, sem espaços.
                    </mat-error>
                  }
                  @if (referenciaCtrl.errors?.['required']) {
                    <mat-error>
                      Obrigatório.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div class="mt-3" style="width: 440px;">
              <!--
              <label class="form-control checkbox-label">
                <input type="checkbox" name="checkbox" />
                <span class="pl-1">Atualizar ficheiro JS</span>
                <button type="button" class="btn btn-upload ml-3">
                  <span>Upload Excel</span>
                  <img src="../../../../assets/Icons/upload.png" alt="Upload">
                </button>
              </label>
              -->
              <label class="form-control checkbox-label">
                <input type="checkbox" name="checkbox" (change)="xmlStatusChanged($event)" />
                <span class="pl-1">Ver XML</span>
              </label>
              <label class="form-control checkbox-label">
                <input type="checkbox" name="checkbox" (change)="fileStatusChanged($event)" />
                <span class="pl-1">Ficheiro "{{fileDate}}"</span>
                <button type="button" class="btn btn-download ml-3" (click)="downloadFile()">
                  <span>Download</span>
                  <img src="../../../../assets/Icons/download.png" alt="Download">
                </button>
              </label>
            </div>
            <button class="btn-processar mt-4" (click)="processar()" [disabled]="loading || !isInputValid()">
              <span>Processar</span>
              <img src="../../../../assets/Icons/check-line.png" alt="Check">
            </button>
          </form>
          <!--*REGISTOS IMPORTADOS-->
          @if (!loading && data) {
            <div>
              @if (data.length > 0 && data[0].statusCode === 200) {
                <div>
                  <h2 class="mt-4">Resultado:</h2>
                  <div class="response-container">
                    @for (produto of data; track produto) {
                      <div class="file-container">
                        <div class="file-info">
                          <p>Produto #{{ produto.reference }} @if (produto.errorMessage) {
                            <span>| {{produto.errorMessage}}</span>
                          }</p>
                          @if (xml) {
                            <div>
                              <br>
                                <p><span>Pedido:</span> {{ produto.pedido }}</p>
                                <br>
                                  <p><span>Resposta:</span> {{ produto.resposta }}</p>
                                  <br>
                                    <p><span>Pedido Tabela Preço:</span> {{ produto.pedidoPreco }}</p>
                                    <br>
                                      <p><span>Resposta Tabela Preço:</span> {{ produto.respostaPreco }}</p>
                                      <hr>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            <app-footer></app-footer>
          </div>
        </div>